import { useQuery } from '@apollo/client';

import GET_ACADEMY_DETAIL from './graphql/AcademyDetail.v4.graphql';
import type {
  AcademyDetail,
  AcademyDetailVariables,
} from './graphql/types/AcademyDetail';

const useAcademyDetail = ({ slug }: { slug: string }) => {
  const { data, loading, error, refetch } = useQuery<
    AcademyDetail,
    AcademyDetailVariables
  >(GET_ACADEMY_DETAIL, {
    variables: {
      slug: slug,
    },
    skip: !slug,
    context: { clientName: 'v4' },
    notifyOnNetworkStatusChange: true,
  });

  return {
    academyDetail: data,
    loadingDetail: loading,
    error,
    refetch,
  };
};

export default useAcademyDetail;
